import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import type { UserRole, UserProfile } from '@festpix/types';

export async function getUserProfile(uid: string): Promise<UserProfile | null> {
  const userDoc = await getDoc(doc(db, 'users', uid));

  if (!userDoc.exists()) {
    return null;
  }

  return {
    uid: userDoc.id,
    ...userDoc.data(),
  } as UserProfile;
}

export async function createUserProfile(
  uid: string,
  email: string,
  name: string,
  role: UserRole = 'attendee'
): Promise<void> {
  await setDoc(doc(db, 'users', uid), {
    email,
    name,
    role,
    createdAt: new Date(),
  });
}

export async function ensureUserProfile(
  uid: string,
  email: string
): Promise<UserProfile> {
  let profile = await getUserProfile(uid);

  if (!profile) {
    await createUserProfile(uid, email, email.split('@')[0], 'attendee');
    profile = await getUserProfile(uid);
  }

  return profile!;
}

export type { UserRole, UserProfile };
